import { nativeBackPath } from './nativeBackForms';

export type BackScreen = { key: string; href: string; pathname: string; index: number };

export const canPreviewIosBack = (options: {
  overlay: boolean;
  formState: string;
  pending: boolean;
  keyboard: boolean;
  root: boolean;
}) =>
  !options.overlay &&
  options.formState === 'ready' &&
  !options.pending &&
  !options.keyboard &&
  !options.root;

/** Exact history entry, or the canonical parent when a handler / cold link owns Back. */
export const iosBackPreviewTarget = (
  screens: Map<number, BackScreen>,
  current: BackScreen,
  canGoBack: boolean,
  parent?: string
): BackScreen | undefined => {
  const previous = screens.get(current.index - 1);
  if (
    !parent &&
    canGoBack &&
    previous &&
    !/\/(sign-in|sign-up|forgot-password|reset-password)(\/|$)/.test(previous.pathname)
  )
    return previous;
  if (!parent) return undefined;
  const locale = /^\/(ru|en)(?=\/|$)/.exec(current.pathname)?.[0] ?? '';
  let target: BackScreen | undefined;
  for (const screen of screens.values()) {
    if (screen.href === `${locale}${parent}` && nativeBackPath(screen.pathname) === parent)
      target = screen;
  }
  return target;
};
